import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/theme.css";
import ProductsPage from "./features/products/ProductsPage";
import AuthPage from "./features/auth/AuthPage";
import DashboardPage from "./features/dashboard/DashboardPage";
import UserPage from "./features/customer/UserPage";
import AgeGroupProductsPage from "./features/age-group-product/AgeGroupProductsPage";
import TypeProductPage from "./features/type-product/TypeProductPage";
import CategoriesPage from "./features/categories/CategoriesPage";
import ProtectedRoute from "./shared/utils/ProtectedRoute";
import ListProductCategoryPage from "./features/list-product-category/ListProductCategoryPage";
import OrderPage from "./features/order/OrderPage";
import BannerPage from "./features/banner/BannerPage";
import PromoProductPage from "./features/promo/PromoProductPage";
import ArtikelPage from "./features/artikel/ArtikelPage";
import CareerPage from "./features/career/CareerPage";
import { UserProvider } from "./shared/context/authContext";

const App = () => {

  return (
    <>
      {/* <UserProvider> */}
        <Router>
          <Routes>
            <Route path="/login" element={<AuthPage title="AuthPage" />} />
            <Route
              index
              path="/"
              element={<DashboardPage title="Dasboard" />}
            />
            <Route
              path="/product"
              element={<ProductsPage title="Products Page" />}
            />
            <Route
              path="/age-group-products"
              element={<AgeGroupProductsPage title="Age Group Product" />}
            />
            <Route
              path="/type-products"
              element={<TypeProductPage title="Type Products" />}
            />
            <Route
              path="/categories"
              element={<CategoriesPage title="Categories Page" />}
            />
            <Route
              path="/customer"
              element={<UserPage title="User Page" />}
            />
            <Route
              path="/list-product-category"
              element={
                <ListProductCategoryPage title="List Product Category Page" />
              }
            />
            <Route path="/order" element={<OrderPage title="Order Page" />} />
            <Route
              path="/banner"
              element={<BannerPage title="Banner Page" />}
            />
            <Route
              path="/promo"
              element={<PromoProductPage title="Promo Page" />}
            />
            <Route
              path="/artikel"
              element={<ArtikelPage title="Artikel Page" />}
            />
            <Route
              path="/career"
              element={<CareerPage title="Career Page" />}
            />
          </Routes>
        </Router>
      {/* </UserProvider> */}
    </>
  );
};

export default App;
